import apiRequest from './client';

// RÈG 1 — Ratio Konbinezon (menu Securite). Portée company (par défaut) / group /
// bank ; au plus une règle par cible côté backend (KonbinezonRatioRule).

export const listKonbinezonRules = ({ group, bank } = {}) => {
  const params = new URLSearchParams();
  if (group) params.set('group', group);
  else if (bank) params.set('bank', bank);
  const qs = params.toString();
  return apiRequest(`/konbinezon-ratio-rules/${qs ? `?${qs}` : ''}`);
};

export const createKonbinezonRule = (data) =>
  apiRequest('/konbinezon-ratio-rules/', { method: 'POST', body: data });

export const updateKonbinezonRule = (id, data) =>
  apiRequest(`/konbinezon-ratio-rules/${id}/`, { method: 'PATCH', body: data });

export const deleteKonbinezonRule = (id) =>
  apiRequest(`/konbinezon-ratio-rules/${id}/`, { method: 'DELETE' });
